export default "__VITE_ASSET__DCR5kAux__"